export const paymentExportColumnNames = [
    "createdAt",
    "createdAtTimestamp",
    "totalAmount",
    "paymentMethod",
    "dafProvider",
    "status",
    "payoutDate",
    "extraDonation",
    "refundedAmount",
    "recurringStatus",
    "discount",
    "firstName",
    "lastName",
    "email",
    "companyName",
    "address",
    "city",
    "postalCode",
    "region",
    "country",
    "locale",
    "receiptNumber",
    "receiptUrl",
    "eligibleAmount",
    "details",
    "rateTitle",
    "bidStatus",
    "itemAmount",
    "ticketNumber",
    "addOnNumber",
    "eTicketUrl",
    "canceled",
    "occurrence",
    "expirationDate",
    "scans",
    "lastScan",
    "formTitle",
    "formLink",
    "campaignTitle",
    "teamTitle",
    "teamCreationDate",
    "note",
    "inHonourName",
    "customQuestions",
    "taxes",
    "selectedFund",
    "paymentHandler",
];
export const guestListExportColumnNames = [
    "guestFirstName",
    "guestLastName",
    "guestEmail",
    "guestAddress",
    "guestCity",
    "guestRegion",
    "guestPostalCode",
    "guestCountry",
    "buyerFirstName",
    "buyerLastName",
    "buyerAddress",
    "buyerCity",
    "buyerRegion",
    "buyerPostalCode",
    "buyerCountry",
    "buyerEmail",
    "ticketNumber",
    "addOnNumber",
    "ticketType",
    "customQuestions",
    "eventDate",
    "ticketNotes",
    "status",
];
export const fulfillmentExportColumnNames = [
    "buyerName",
    "buyerEmail",
    "items",
    "questionsAndNotes",
    "deliveryMethod",
    "fulfillmentStatus",
    "shippingAddress",
];
export var ExportPaymentsType;
(function (ExportPaymentsType) {
    ExportPaymentsType["ItemizedPayments"] = "ItemizedPayments";
    ExportPaymentsType["Payments"] = "Payments";
})(ExportPaymentsType || (ExportPaymentsType = {}));
export var ExportFormType;
(function (ExportFormType) {
    ExportFormType["AllForms"] = "AllForms";
    ExportFormType["DonationForm"] = "DonationForm";
    ExportFormType["PeerToPeer"] = "PeerToPeer";
    ExportFormType["Event"] = "Event";
    ExportFormType["Raffle"] = "Raffle";
    ExportFormType["Sweepstakes"] = "Sweepstakes";
    ExportFormType["Custom"] = "Custom";
    ExportFormType["Membership"] = "Membership";
    ExportFormType["Auction"] = "Auction";
    ExportFormType["Shop"] = "Shop";
})(ExportFormType || (ExportFormType = {}));
export var ExportFileType;
(function (ExportFileType) {
    ExportFileType["Excel"] = "Excel";
    ExportFileType["Pdf"] = "Pdf";
})(ExportFileType || (ExportFileType = {}));
